import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import LocalFileInputButton from '../../../core/form/LocalFileInputButton';
import DraftItemAssetsUploadService from '../services/DraftItemAssetsUploadService';

class DraftItemAssetsUploadContainer extends React.Component {
  static propTypes = {
    itemId: PropTypes.string.isRequired,
    itemType: PropTypes.string.isRequired,
    field: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    accept: LocalFileInputButton.propTypes.accept,
    onItemAssetUploadPercentageChange: PropTypes.func,
  };

  draftItemAssetsUploadService = new DraftItemAssetsUploadService(this.props.onItemAssetUploadPercentageChange);
  componentDidMount() {
    this.draftItemAssetsUploadService.init(
      this.props.itemId,
      this.props.itemType,
      this.props.field,
      !!this.props.value
    );
  }

  render() {
    return (
      <LocalFileInputButton
        icon="upload"
        value={this.props.value}
        accept={this.props.accept}
        onChange={this.draftItemAssetsUploadService.handleUpload}
        loading={this.draftItemAssetsUploadService.submit.fetching}
      />
    );
  }
}

export default observer(DraftItemAssetsUploadContainer);
